<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.bxx">
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:16pt;font-family:Arial;">Cored-wire</span>
        </b>
      </p>
      <p>
        <b>
          <span style="font-size:16pt;font-family:Arial;">
            <br>
          </span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span></span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-family:Arial;font-size:12px;">CaSi Wire</span>
          <span style="font-family:Arial;font-size:12px;">:</span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;"></span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-family:Arial;font-size:12px;">
            CA30%MIN&nbsp; SI50%MIN&nbsp; AL2%MAX&nbsp;
            P0.04%MAX&nbsp; C1%MAX
          </span>
          <br>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-family:Arial;font-size:12px;">Size:</span>
          <span style="font-family:Arial;font-size:12px;">5-50MM&nbsp; 90%MIN</span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;"></span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12px;font-family:Arial;">Diameter:</span>
        <span style="font-size:12px;font-family:Arial;">∮</span>
        <span style="font-size:12px;font-family:Arial;">13mm</span>
        <span style="font-size:12.0pt;font-family:宋体;"></span>
      </p>
      <p style="text-align:left;" align="left">
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-family:Arial;font-size:12px;">Weight of wire:</span>
          <span style="font-family:Arial;font-size:12px;">390±10g/M</span>
        </span>
        <span style="font-size:12.0pt;font-family:宋体;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:宋体;">
          <span style="font-family:Arial;font-size:12px;">Weight of alloy:</span>
          <span style="font-family:Arial;font-size:12px;">230±10g/M</span>
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        bxx: require("../../../assets/img/common/bxx.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/bxx.vue